/* eslint-disable react/prop-types */

import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Image from '@base/Image';
import { useIsMobile } from '@stores/AppCommonData';
import Typography from 'aquilla/core/atoms/Typography';
import BackGroundImage from './BackgroundImage';

const leadersImageMobile = 'about/leaders-1.png';
const leadersImageDesktop = 'about/leaders.png';

const Container = styled.div`
  margin-top: ${Spacings.SPACING_36B};
  grid-column: span 24;
  position: relative;
  ${mediaQuery.uptoTablet} {
    margin-top: 98px;
  }
`;

const Mission = styled(Typography)`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.LARGE};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  letter-spacing: 2px;
  color: var(--color-i-green);
  padding-top: ${Spacings.SPACING_16B};
  margin: 0;
  ${mediaQuery.uptoTablet} {
    display: block;
    font-size: ${Fonts.ULTRA_SMALL};
    text-align: center;
    padding-top: 34px;
  }
`;

const Description = styled(Typography)`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.LARGE_HEADING};
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  color: var(--color-i-black);
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoTablet} {
    font-size: ${Fonts.H3};
    text-align: center;
  }
`;

const LeadContainer = styled.div`
  margin-top: ${Spacings.SPACING_14B};
  position: relative;
  min-height: 90vh;
  border-radius: 7.5px;
  overflow: hidden;
  ${mediaQuery.uptoTablet} {
    margin-top: ${Spacings.SPACING_8B};
    min-height: 35vh;
  }
`;

const Leaders = styled(Image)`
  height: auto;
  width: 100%;
  object-fit: contain;
`;

const Info = styled.div`
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(80px);
  border-radius: ${Spacings.SPACING_2B};
  position: absolute;
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B};
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 0s, opacity 700ms;
  ${mediaQuery.uptoTablet} {
    visibility: visible;
    opacity: 1;
    padding: ${Spacings.SPACING_2B};
  }
`;

const Face = styled.div`
  position: absolute;
  width: 150px;
  height: 150px;
  z-index: 100;
  ${mediaQuery.uptoTablet} {
    display: none;
  }
`;

const RFace = styled(Face)`
  left: 275px;
  top: 50px;
`;

const HFace = styled(Face)`
  left: 535px;
  bottom: 215px;
`;

const GFace = styled(Face)`
  right: 220px;
  top: 50px;
`;

const Roman = styled(Info)`
  top: 277px;
  left: 60px;
  ${RFace}:hover ~ & {
    visibility: visible;
    opacity: 1;
  }
  ${mediaQuery.uptoTablet} {
    top: 37%;
    left: 5%;
  }
`;

const Hemesh = styled(Info)`
  bottom: 60px;
  left: 276px;
  ${HFace}:hover ~ & {
    visibility: visible;
    opacity: 1;
  }
  ${mediaQuery.uptoTablet} {
    bottom: 10%;
    left: 21%;
  }
`;

const Gaurav = styled(Info)`
  top: 340px;
  right: 60px;
  ${GFace}:hover ~ & {
    visibility: visible;
    opacity: 1;
  }
  ${mediaQuery.uptoTablet} {
    top: 47%;
    right: 7%;
  }
`;

const Name = styled(Typography)`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.H3};
  line-height: ${Fonts.PARA_LINE_HEIGHT}%;
  color: var(--color-i-white);
  display: block;
  ${mediaQuery.uptoTablet} {
    font-size: 8px;
  }
`;

const Position = styled(Typography)`
  font-size: ${Fonts.LARGE};
  line-height: ${Fonts.HEADER_LINE_HEIGHT}%;
  text-transform: uppercase;
  color: var(--color-i-white);
  ${mediaQuery.uptoTablet} {
    font-size: 6px;
  }
`;

const Faces = styled.div`
  ${mediaQuery.uptoTablet} {
    display: none;
  }
`;

const LeaderName = ({ text, position }) => {
  return (
    <>
      <Name>{text}</Name>
      <Position>{position}</Position>
    </>
  );
};

const LeaderBlock = () => {
  const isMobile = useIsMobile();
  const leadersImage = isMobile ? leadersImageMobile : leadersImageDesktop;
  return (
    <Container>
      <BackGroundImage />
      <Mission variant="h1">FROM THE HEADQUARTERS</Mission>
      <Description variant="h2">Our leaders</Description>
      <LeadContainer>
        <Leaders src={leadersImage} layout="fill" />
        {!isMobile && (
          <Faces>
            <RFace />
            <HFace />
            <GFace />
            <Roman>
              <LeaderName text="Roman Saini" position="Co-Founder" />
            </Roman>
            <Hemesh>
              <LeaderName text="Hemesh Singh" position="Co-Founder and CTO" />
            </Hemesh>
            <Gaurav>
              <LeaderName text="Gaurav Munjal" position="Co-Founder and CEO" />
            </Gaurav>
          </Faces>
        )}
      </LeadContainer>
    </Container>
  );
};

export default LeaderBlock;
